"use client";

import { useSearchParams, useRouter, usePathname } from "next/navigation";
import { cn } from "@/lib/utils/cn";
import type { BlogTag } from "@/lib/blog/types";

export function TagFilter({ tags }: { tags: BlogTag[] }) {
  const searchParams = useSearchParams();
  const router = useRouter();
  const pathname = usePathname();
  const active = searchParams.get("tag");

  function setTag(tag: string | null) {
    const params = new URLSearchParams(searchParams.toString());
    if (tag) params.set("tag", tag);
    else params.delete("tag");
    const qs = params.toString();
    router.replace(qs ? `${pathname}?${qs}` : pathname, { scroll: false });
  }

  return (
    <div className="mb-8 flex flex-wrap gap-2">
      <button
        type="button"
        onClick={() => setTag(null)}
        className={cn(
          "rounded-full border px-3 py-1 text-xs font-medium transition",
          active === null
            ? "border-blue bg-blue/10 text-blue"
            : "border-surface-light/30 bg-surface/40 text-muted-foreground hover:border-surface-light/60",
        )}
      >
        All
      </button>
      {tags.map((tag) => (
        <button
          key={tag}
          type="button"
          onClick={() => setTag(tag)}
          className={cn(
            "rounded-full border px-3 py-1 text-xs font-medium transition",
            active === tag
              ? "border-blue bg-blue/10 text-blue"
              : "border-surface-light/30 bg-surface/40 text-muted-foreground hover:border-surface-light/60",
          )}
        >
          {tag}
        </button>
      ))}
    </div>
  );
}
